import styled from 'styled-components'

export const FullScreenLoadingContainer = styled.div`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f9f5f2;
`